import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link';
import s from './CtaBanner.css';

// Full-width red band: headline + sub + up to two CTAs.
function CtaBanner({
  title,
  subtitle,
  primaryLabel = 'Book a pro',
  primaryTo = '/category?type=all',
  secondaryLabel,
  secondaryTo,
}) {
  return (
    <section className={s.banner}>
      <div className={s.wrap}>
        <h2 className={s.title}>{title}</h2>
        {subtitle ? <p className={s.sub}>{subtitle}</p> : null}
        <div className={s.ctas}>
          {primaryLabel ? (
            <Link to={primaryTo} className={s.btnPrimary}>{primaryLabel}</Link>
          ) : null}
          {secondaryLabel ? (
            <Link to={secondaryTo} className={s.btnSecondary}>{secondaryLabel}</Link>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(CtaBanner);
